import React, { useEffect, useRef, useState } from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import Highlight from 'react-highlight'
import { Button } from 'reactstrap';
import 'animate.css';
import Normal from './input/Normal';
import Customize from './input/Customize';
import NewSources from './input/NewSources';
const TrayInfo = ({ loading, tracking, open, setRes, response, setOpenTray }) => {
    const scrollDiv = useRef(null)
    const parse = response && JSON.parse(response?.config?.data)
    const jsonDATA = response && JSON.stringify(parse, null, 2)
    const [choosen, setChoosen] = useState("normal")
    const [scrollAnimate, setScroll] = useState("")
    const [printData, setPrintData] = useState("/*Compiler..*/")
    const header = `${response?.config?.method?.toUpperCase()} ${response?.config?.url} HTTP:/1.1\nOrigin: ${response?.config?.url}`
    const isArr = [
        `Method: ${response?.config?.method?.toUpperCase()}`,
        `Access_control_alllow_Origin: ${response?.config?.url}`,
        `Date: ${new Date()}`,
        `ContentType: ${response?.config?.headers?.Accept}`,
    ].join("\n");
    useEffect(() => {
        if (response) {
            scrollDiv.current.scrollIntoView({ behavior: "smooth" });
            setScroll("animate__animated animate__fadeInUp")
        }
    }, [response]);
    const Body = `HTTP:/1.1${response?.name !== "Error" ? " 200 OK" : "Error"}\n\n${isArr}`;
    const isOpen = open ? "slideInUp" : "slideOutDown"
  
    return (
        <div className={`tray-info animate__animated animate__${isOpen}`} >
            <div className='tray-header' style={{ padding: 12, textAlign: "end", display: "flex", justifyContent: "space-between" }}>
                <h4>Let's Try</h4>
                <div className='d-flex gap-4'>
                    <FormGroup>
                        <Input
                            name="radio1"
                            type="radio"
                            onChange={() => {
                                setRes(null)
                                setChoosen("normal")
                                setPrintData("/*Compiler..*/")
                            }}
                            checked={choosen === "normal"}
                        />
                        {' '}
                        <Label check>
                            Normal Tracker
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Input
                            name="radio1"
                            type="radio"
                            onChange={() => {
                                setRes(null)
                                setChoosen("customize")
                                setPrintData("/*Compiler..*/")
                            }}
                            checked={choosen === "customize"}
                        />
                        {' '}
                        <Label check>
                            Customized Tracker
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Input
                            name="radio1"
                            type="radio"
                            onChange={() => {
                                setRes(null)
                                setChoosen("new-sources")
                                setPrintData("/*Compiler..*/")
                            }}
                            checked={choosen === "new-sources"}
                        />
                        {' '}
                        <Label check>
                            New Sources Tracker
                        </Label>
                    </FormGroup>
                </div>
                <Button onClick={setOpenTray} close />
            </div>
            <div className='tray-body' style={{ paddingLeft: 20, paddingRight: 20, overflowY: "scroll", height: "90vh", marginBottom: 16 }} >
                {loading && <div className='loader-fade'></div>}
                {loading && <div className='loader-position'><i className="fa fa-spinner fa-spin fa-2x"></i></div>}
                <div>
                    <Row style={{ paddingTop: "2vh" }}>
                        <h3>Request Preview</h3>
                    </Row>
                    <Row style={{ paddingTop: "2vh" }}>
                        <Col sm="6">
                            {choosen === "normal" && <Normal tracking={tracking} print={setPrintData} />}
                            {choosen === "customize" && <Customize tracking={tracking} print={setPrintData} />}
                            {choosen === "new-sources" && <NewSources tracking={tracking} print={setPrintData} />}
                        </Col>
                        <Col sm="6" >
                            <Highlight innerHTML={true}>{'<b>Generating Scripts: </b>'}</Highlight>
                            <Highlight className='fontSizing' language="javascript">
                                {printData}
                            </Highlight>
                        </Col>
                    </Row>
                    {response && !loading && <div className='divider'></div>}
                    <div ref={scrollDiv} id="response-preview" className={scrollAnimate}>
                        {
                            response && <>
                                <Row>
                                    <h3>Response Preview</h3>
                                </Row>
                                <Row style={{ paddingTop: "2vh" }}>
                                    <Col sm="6">
                                        <Col sm="12">
                                            <Highlight innerHTML={true}>{'<b>Request URL: </b>'}</Highlight>
                                            <Highlight className='fontSiz' language="javascript">
                                                {header}
                                            </Highlight>
                                        </Col>
                                        <Col sm="12">
                                            <Highlight innerHTML={true}>{'<b>HTTP Request: </b>'}</Highlight>
                                            <Highlight language="javascript">
                                                {Body}
                                            </Highlight>
                                        </Col>
                                        {response?.name === "Error" && <Col sm="12">
                                            <Highlight innerHTML={true}>{`<b>Status ${!response?.status ? "Error" : response?.status}: </b>`}</Highlight>
                                            <Highlight language="javascript">
                                                {response?.stack}
                                            </Highlight>
                                        </Col>}
                                    </Col>
                                    <Col sm="6" >
                                        <Highlight innerHTML={true}>{'<b>Request Payload: </b>'}</Highlight>
                                        <Highlight language="Json">
                                            {jsonDATA}
                                        </Highlight>
                                    </Col>
                                </Row></>
                        }
                    </div>
                </div>
            </div>
        </div >
    )
}

export default TrayInfo